import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ImageChecker from "../../Generic/ImageChecker";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
} from "../../../Redux/actions/crudActions";
import { errorParser } from "../../../utils/helpers";
import {
  getPullOutItems,
  setPullOut,
} from "../../../Redux/actions/PulloutActions";

import { getProduct } from "../../../Redux/actions/productActions";
import {
  setProductInventory,
  setProductInventoryWithLocation,
} from "../../../Redux/actions/inventoryActions";

import { getLocations } from "../../../Redux/actions/locationsActions";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const { pullOutItems, locations } = useSelector(
    (state) => ({
      pullOutItems: state.pullOut.pullOutItems,
      locations: state.locations.locations,
    }),
    shallowEqual
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [categorized, setCategorized] = useState([]);
  const [itemcount, setItemcount] = useState([]);
  const [createDate, setCreatedDate] = useState(moment());
  const [hqloc, setHQloc] = useState(null);

  useEffect(() => {
    dispatch(getLocations());
  }, []);

  useEffect(() => {
    if (locations) {
      locations.map((loc) => {
        if (loc.commissary) {
          console.log(loc);
          setHQloc(loc);
        }
      });
    }
  }, [locations]);

  useEffect(() => {
    if (isModalVisible) {
      dispatch(getPullOutItems());
    }
  }, [isModalVisible]);

  useEffect(() => {
    if (pullOutItems) {
      docategorized();
      console.log(pullOutItems);
    }
  }, [pullOutItems]);

  const docategorized = () => {
    var categories = [];

    pullOutItems.map((it) => {
      if (!categories.includes(it.category_name)) {
        categories.push(it.category_name);
      }
    });
    var newcats = [];
    categories.map((ct) => {
      var catprods = [];
      pullOutItems.map((it) => {
        if (ct == it.category_name) {
          catprods.push(it);
        }
      });
      var sortedprods = catprods.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
      var newcatp = {
        category: ct,
        products: sortedprods,
      };
      newcats.push(newcatp);
    });

    console.log(newcats);
    setCategorized(newcats);
  };

  const chagnequantity = (prod, count) => {
    var newItemCount = itemcount;
    newItemCount[prod] = count;
    setItemcount(newItemCount);
    console.log(newItemCount);
  };

  const renderTable = (currentgroup) => {
    const columns = [
      {
        title: "Image",

        render: (text, record, index) => {
          return (
            <ImageChecker
              url={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
              success={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
                  alt="image"
                  className={"prodimage"}
                />
              }
              fail={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                  alt="image"
                  className={"prodimage"}
                />
              }
            />
          );
        },
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: "100rem",
        sorter: {
          compare: (a, b) => a.name - b.name,
        },

        search: "name",
      },
      {
        title: "current qty",
        dataIndex: "quantity",
        key: "quantity",

        render: (text, record, index) => {
          return record.second_unit_rate &&
            record.second_unit &&
            parseFloat(record.second_unit_rate) > 0 ? (
            <span>
              {`${(
                parseFloat(text) / parseFloat(record.second_unit_rate)
              ).toFixed(2)} ${record.second_unit}`}{" "}
            </span>
          ) : (
            <span>{`${parseFloat(text).toFixed(2)} ${record.unit}`} </span>
          );
        },
      },
      {
        title: "count",

        render: (text, record, index) => {
          return (
            <div className="vertical-flex">
              <InputNumber
                min={0}
                max={
                  record.second_unit_rate &&
                  record.second_unit &&
                  parseFloat(record.second_unit_rate) > 0
                    ? parseFloat(record.quantity) /
                      parseFloat(record.second_unit_rate).toFixed(2)
                    : record.quantity
                }
                width={"100%"}
                defaultValue={0}
                step={1}
                onChange={(e) => {
                  chagnequantity(record.id, e);
                }}
              />
              {record.second_unit_rate &&
              record.second_unit &&
              parseFloat(record.second_unit_rate) > 0 ? (
                <span className="flex-end">{record.second_unit} </span>
              ) : (
                <span className="flex-end">{record.unit}</span>
              )}
            </div>
          );
        },
      },
    ];

    return (
      <Collapse className={"category_containter"}>
        <Panel header={currentgroup.category} key="1">
          <Table
            columns={columns}
            dataSource={currentgroup.products}
            pagination={false}
            showHeader={false}
          />
        </Panel>
      </Collapse>
    );
  };

  const summarizePullout = (thisitemcount) => {
    var pullout_items = [];

    Object.entries(thisitemcount).map((item) => {
      var item_id = item[0];
      var item_quantity = item[1];

      if (item_quantity > 0) {
        var current_prod = pullOutItems.filter((x) => x.key == item_id);
        if (current_prod[0]) {
          current_prod = current_prod[0];

          var usequantity = item_quantity;
          if (
            current_prod.second_unit_rate &&
            current_prod.second_unit &&
            parseFloat(current_prod.second_unit_rate) > 0
          ) {
            usequantity =
              parseFloat(item_quantity) *
              parseFloat(current_prod.second_unit_rate);
          }

          var recorded_product = {
            ...current_prod,
            pull_out_quantity: usequantity,
          };

          pullout_items.push(recorded_product);
        }
      }
    });

    console.log(pullout_items);
    if (pullout_items.length > 0) {
      createPullout(pullout_items);
    } else {
      message.warning("input quatity for an item");
    }
  };

  const createPullout = async (pullout_items) => {
    if (!loading && hqloc) {
      setLoading(true);
      message.info("recording pullout");

      await Promise.all(
        pullout_items.map(async (indx, i) => {
          var product3 = await dispatch(
            setProductInventory(
              indx.id,
              indx.name,
              indx.pull_out_quantity,
              "subtract",
              "pulled out"
            )
          );
          var product4 = await dispatch(
            setProductInventoryWithLocation(
              indx.id,
              indx.name,
              indx.pull_out_quantity,
              "add",
              `pulled out from ${indx.location_name}`,
              hqloc.id,
              hqloc.name
            )
          );

          message.info(
            `(${i + 1}/${pullout_items.length})  ${indx.name} updated`
          );
        })
      );

      var newsold = await dispatch(setPullOut(pullout_items, createDate));

      setLoading(false);
      closeModal("reset");
    }
  };
  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  };

  const footer = () => {
    return (
      <div className="addsalesfooter">
        <div>
          <DatePicker
            defaultValue={createDate}
            value={createDate}
            disabledDate={disabledDate}
            onChange={(e) => {
              setCreatedDate(e);
            }}
          />
        </div>
        <div>
          <Popconfirm
            title="Are you sure this list is correct?"
            onConfirm={() => {
              summarizePullout(itemcount);
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary" loading={loading}>
              add
            </Button>
          </Popconfirm>
        </div>
      </div>
    );
  };

  const closeModal = (action) => {
    if (!loading) {
      setItemcount([]);

      setIsModalVisible(false);
      onModalClose(action);
    }
  };

  return (
    <>
      <div className={"addeditbutton"}>
        <Button
          type="primary"
          shape="round"
          icon={<PlusOutlined />}
          onClick={() => {
            setIsModalVisible(true);
            setLoading(false);
          }}
        >{`Add Pull Out Items`}</Button>
      </div>

      {isModalVisible && hqloc ? (
        <Modal
          title={`Add Pull Out Items`}
          visible={isModalVisible}
          className={"minwidthis32"}
          footer={footer()}
          onCancel={() => {
            closeModal();
          }}
        >
          <div className="wastes-content">
            {categorized.map((cat) => {
              return renderTable(cat);
            })}
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
